import { map } from 'lodash';
import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18next';

let setlang = i18n.language;

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  citiesList: [],
  categoriesList: [],
  companyList: [],
  dashboardCount: [],
};

const slice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MANAGE citiesList
    getCitiesListSuccess(state, action) {
      state.isLoading = false;
      state.citiesList = action.payload;
    },

    // GET MANAGE categoriesList
    getCategoriesListSuccess(state, action) {
      state.isLoading = false;
      state.categoriesList = action.payload;
    },

    // GET MANAGE companyList
    getCompanyListSuccess(state, action) {
      state.isLoading = false;
      state.companyList = action.payload;
    },
    // GET MANAGE getDashboardSuccess
    getDashboardSuccess(state, action) {
      state.isLoading = false;
      state.dashboardCount = action.payload;
    },

  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getCitiesList() {
    return async (dispatch) => {

      dispatch(slice.actions.startLoading());

      try {
        const response = await axios.get('https://api.asystent.biz/api/'+setlang+'/cities');

        dispatch(slice.actions.getCitiesListSuccess(response.data.cities));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}

// ----------------------------------------------------------------------

export async function getCoursesList() {
  try {
    const response = await axios.get('https://api.asystent.biz/api/courses');

    return response.data
  } catch (error) {
    console.log(slice.actions.hasError(error));
  }
}

// ----------------------------------------------------------------------

export function getCompanyList() {
    return async (dispatch) => {

      dispatch(slice.actions.startLoading());

      try {
        const response = await axios.get('https://api.asystent.biz/api/company');

        dispatch(slice.actions.getCompanyListSuccess(response.data.company));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}
  
// ----------------------------------------------------------------------

export function getCategoriesList() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('https://api.asystent.biz/api/'+setlang+'/categories');
        
        dispatch(slice.actions.getCategoriesListSuccess(response.data.categories));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}
// ----------------------------------------------------------------------

export function getDashboard() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get('https://api.asystent.biz/api/dashboard');
        
        dispatch(slice.actions.getDashboardSuccess(response.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}